"use client";
import React, { useEffect, useState } from "react";
import "./header.scss";
import Image from "next/image";
import Link from "next/link";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { UserData, AvalableCredits } from "@/app/redux/slice";
import { animateScroll as scroll } from "react-scroll";
import { usePathname } from "next/navigation";

import CommingSoonModal from "../modals/commingSoonModal";
import DesktopNavbar from "./desktopNavbar";
import logoHeader from "@/../public/header/logoHeader.png";
import mobileLogo from "@/../public/header/mobileLogo.png";
import Profile from "../profile";
import MobileNavbar from "./mobileNavbar";
import Credits from "../credits";
import app from "../../firebase-config";
import { FaBarsStaggered } from "react-icons/fa6";
import axios from "axios";

import BuyCraditsModal from "@/components/modals/buyCraditsModal";

import snapshatCoin from "@/../public/header/coin.png";
import PageLoader from "../modals/pageLoader";

import {
  onAuthStateChanged,
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  RecaptchaVerifier,
  signInWithPhoneNumber,
} from "firebase/auth";

import bar from "@/../public/header/bar.svg";
// import bar from "@/../public/header/bar.png";
import UserDB from "@/utils/userdb";
import profile from "@/../public/profile/profile.png";
import { allRoutes } from "@/data/allRoutes";

export default function Header() {
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  // const [isCreditsOpen, setIsCreditsOpen] = useState(false);
  const [user, setUser] = useState();
  const [credits, setCredits] = useState(0);
  const auth = getAuth();
  const [isShowSidebar, setIsShowSidebar] = useState(false);
  const [showCommingSoonModal, setShowCommingSoonModal] = useState(false);
  const selector = useSelector((data) => data.contactRef);
  const selector2 = useSelector((data) => data.priceRef);
  const creditSelector = useSelector((data) => data.credits);
  const imgGeneratedArrSelector = useSelector((data) => data.imgGeneratedArr);
  const pathname = usePathname();
  const dispatch = useDispatch();
  const [showBuyCraditsModal, setShowBuyCraditsModal] = useState(false);
  const [gallaryArr, setGallaryArr] = useState([]);
  const [redirectingPath, setRedirectingPath] = useState("");
  const [isShowPageLoader, setIsShowPageLoader] = useState(true);

  useEffect(() => {
    auth.onAuthStateChanged(async function (_user) {
      if (_user != null) {
        const response = await UserDB.insertUser(
          _user.uid,
          _user.email,
          _user.phoneNumber,
          _user.displayName,
          _user.photoURL,
          _user.metadata.createdAt,
          Date.now()
        );
        // response.data.redeemCredits = redeemCredits;

        if (response.data.phoneNumber.length > 0)
          response.data.photoURL =
            UserDB.getServerURI() + "/" + response.data.photoURL;

        setUser(response.data);
        setCredits(response.data.credits);

        UserDB.setUser(response.data);
        UserDB.setCredits(response.data.credits);
        localStorage.setItem("isUserLoggedIn", "true");

        if (response.data.credits === 0 || response.data.credits < 0) {
          setShowBuyCraditsModal(true);
        }
      } else {
        setUser(null);
        UserDB.setUser(null);
        setIsProfileOpen(false);
        // setIsCreditsOpen(false);
        // No user is signed in.
      }
    });
  }, []);

  /*   function redeemCredits(_credits) {
    if (UserDB.getUser() && UserDB.getCredits() > 0) {
      var newCredits = UserDB.getCredits() - _credits;
      console.log(newCredits);

      setCredits(newCredits);
      UserDB.setCredits(newCredits);
    }
  } */

  // sending user and available credits
  useEffect(() => {
    const handlePageLoader = () => {
      if (user) {
        dispatch(AvalableCredits(credits));
        dispatch(UserData(user));
        setIsShowPageLoader(false);
      }
    };

    if (user) {
      handlePageLoader();
    } else if (user == null) {
      setTimeout(() => {
        setIsShowPageLoader(false);
      }, 2000);
    }
  }, [user]);

  const getAllImages = () => {
    UserDB.getImages().then((res) => {
      setGallaryArr(res.data.reverse());
    });
  };

  // gallery
  useEffect(() => {
    if (user) {
      getAllImages();
    }
    if (creditSelector) {
      // console.log(creditSelector);
      setCredits(creditSelector[creditSelector.length - 1]);
    }
  }, [creditSelector]);

  const handlePriceScroll = () => {
    if (selector2.price) {
      console.log("working");
      scroll.scrollTo(selector2.price.offsetTop, {
        duration: 500,
        smooth: "easeInOutQuart",
      });
    }
  };

  // try to face swap button
  useEffect(() => {
    const isUserLoggedIn = localStorage.getItem("isUserLoggedIn");
    if (isUserLoggedIn) {
      setRedirectingPath("/face-swap/single-ai-face-swap");
    } else {
      setRedirectingPath("/signin");
    }
  }, [pathname, user]);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Set initial state
    handleResize();

    // Add resize listener
    window.addEventListener("resize", handleResize);

    // Clean up listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // not showing header
  if (
    pathname === "/output-view" ||
    pathname === "/ai-face-swap-photo-enhancer/durga-maa"
  ) {
    return null;
  }

  return (
    <header className={`Header`}>
      {/* {isShowPageLoader && <PageLoader />} */}

      <div className={`flex-row-center barLogo`}>
        <div onClick={() => setIsShowSidebar(true)} className={`bar`}>
          <Image src={bar} alt="bar" />
        </div>

        <Link href={"/"}>
          <div className={`logoContainer`}>
            <Image src={isMobile ? mobileLogo : logoHeader} alt="logo" />
          </div>
        </Link>
      </div>

      <div className={`flex-row-center rightContainer`}>
        {/* price */}
        {/*  {pathname !== "/" && pathname !== "/#price" && (
          <a href="/#price">
            <button
              onClick={handlePriceScroll}
              className={`btn1 ${styles.price}`}
            >
              Price
            </button>
          </a>
        )}

        {(pathname === "/" || pathname === "/#price") && (
          <button
            onClick={handlePriceScroll}
            className={`btn1 ${styles.price}`}
          >
            Price
          </button>
        )} */}

        {/* credit */}
        {/*  <button className={`btn3 ${styles.credit}`}>
          Credit {user == null ? "00" : String(credits)}
        </button> */}

        {user && user?.creditType !== "FREE" && (
          <div className={`flex-row-center creditContainer`}>
            <div className={`flex-row-center coinImg`}>
              <Image src={snapshatCoin} alt="snapshat-coin" />
            </div>
            <p className={`newCredit`}>
              {user == null ? "0" : String(credits)}
            </p>
          </div>
        )}

        {/* try for free */}
        {/*     {((user?.creditType === "FREE" &&
          user?.freeCreditsHistory?.faceSwap > 0) ||
          !user) && (
          <Link
            // href={{
            //   pathname: redirectingPath,
            //   query: {
            //     path: "/face-swap/single-ai-face-swap",
            //   },
            // }}
            href={`${allRoutes.faceSwap}`}
          >
            <button className={`btn1 ${styles.tryToBtn} ${styles.price}`}>
              Try for free
            </button>
          </Link>
        )} */}

        {/* profile-section */}
        <div className={`profile`}>
          {isProfileOpen && (
            <Profile
              user={user}
              setIsProfileOpen={setIsProfileOpen}
              gallaryArr={gallaryArr}
              getAllImages={getAllImages}
            />
          )}
        </div>

        {/* credits-section */}
        {/* <div className={styles.credits}>
          {isCreditsOpen && <Credits user={user} setIsCreditsOpen={setIsCreditsOpen} />}
        </div> */}

        {/* desktop navbar */}
        <div className={`desktopNavbar`}>
          <DesktopNavbar
            setIsProfileOpen={setIsProfileOpen}
            isUserPresent={user}
            selector={selector}
            path={pathname}
          />
        </div>
        <div className={`signProfile`}>
          {!user && (
            <Link
              href={{
                pathname: "/signin",
                query: { pathname },
              }}
              className={`navLinks ${
                !isMobile ? `btn1 desktopSignin` : `signIn`
              } `}
            >
              Sign in
            </Link>
          )}

          {/* Profile */}
          {user && (
            <div
              className={`profiles`}
              onClick={() => setIsProfileOpen((pre) => !pre)}
            >
              <img
                className={`userProfileImg`}
                src={user.photoURL === "" ? profile.src : user.photoURL}
                alt="profile"
              />
            </div>
          )}
        </div>

        {/* <FaBarsStaggered
          className={styles.bar}
          onClick={() => setIsShowSidebar(true)}
        /> */}

        {/* mobile navbar */}
        <div className={`mobileNavbar`}>
          <MobileNavbar
            isShowSidebar={isShowSidebar}
            setIsShowSidebar={setIsShowSidebar}
            setIsProfileOpen={setIsProfileOpen}
            isUserPresent={user}
            setShowCommingSoonModal={setShowCommingSoonModal}
            selector={selector}
            path={pathname}
          />
        </div>
      </div>

      {/* comming soon modal */}
      {showCommingSoonModal && (
        <CommingSoonModal
          showCommingSoonModal={showCommingSoonModal}
          setShowCommingSoonModal={setShowCommingSoonModal}
        />
      )}

      {/*   {showBuyCraditsModal && (
        <BuyCraditsModal setShowBuyCraditsModal={setShowBuyCraditsModal} />
      )} */}
    </header>
  );
}
